import React from 'react';
import DialogBox from './DialogBox';

const ConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Action", 
  message, 
  confirmText = "Delete", 
  cancelText = "Cancel",
  isDestructive = true,
  showConfirmButton = true // New prop to control confirm button visibility
}) => {
  console.log('ConfirmationDialog rendered, isOpen:', isOpen);
  
  const handleConfirm = () => {
    console.log('ConfirmationDialog confirm clicked');
    onConfirm();
    onClose();
  };

  const confirmButton = (
    <button
      onClick={handleConfirm}
      className={`mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:mt-0 sm:w-auto ${
        isDestructive 
          ? 'bg-red-600 hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600' 
          : 'bg-primary hover:bg-primary-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'
      }`}
    >
      {confirmText}
    </button>
  );

  return (
    <DialogBox
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      actionButton={showConfirmButton ? confirmButton : null}
      showIcon={isDestructive}
    >
      <p className="text-sm text-muted-foreground">{message}</p>
    </DialogBox>
  );
};

export default ConfirmationDialog;
